import { styled } from '@mui/system';
export const DividerLine = styled("div")(({
  theme,
  customStyle
}) => ({
  width: '98%',
  height: 2,
  opacity: 0.5,
  backgroundColor: theme.palette.primary.main,
  margin: "10px auto",
  ...customStyle
}));